"use client";

import FrameConfig from "@lib/classes/FrameConfig";
import { localeMap } from "@lib/i18n";
import Script from "next/script";

export default function GoogleMaps({ apiKey }: { apiKey?: string }) {
  if (!apiKey) return null;

  return (
    <Script
      src={`https://maps.googleapis.com/maps/api/js?loading=async&libraries=places,geometry&key=${apiKey}&language=${
        localeMap[new FrameConfig().language || "en"] || new FrameConfig().language
      }&callback=Function.prototype`}
    />
  );
}
